import React from 'react'
import './index.css';
import { 
  Container, 
  Row, 
  Col, 
  Card,
 } from 'react-bootstrap'

 import {
  CrosBorder,
  IconB2B,
  IconB2C,
  IconC2C
 } from '../../../assets/image/index.js'

const index = () => {
  return (
    <div className='home-layanan align-items-center justify-content-center'>
        <Container className='home-layanan-container align-items-center justify-content-center'> 
            <h1 className='text-center'>Layanan Pilihan Untuk Anda</h1>
            <p>Kami berkomitmen untuk selalu menjaga kepercayaan dan kepuasan pelanggan dengan memberikan service yang terbaik dan termurah sesuai dengan kebutuhan anda.</p>
            <Row className='home-layanan-row '>
              <Col sm={3} className='p-3'>
                <Card className='layanan-card '>                  
                  <Card.Body className='text-center'>
                    <Card.Title>Business to Business  <br/>
                    (B2B)</Card.Title>
                    <Card.Img variant="top" src={IconB2B} />
                    <Card.Text>
                      HBU Express melayani ribuan 
pelanggan korporat yang  mengantarkan barang 
ke kantor-kantor dan lokasi-lokasi bisnis.
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>

              <Col sm={3} className=' p-3'>
              <Card className='layanan-card'>                  
                  <Card.Body className='text-center'>
                    <Card.Title>Business to Customer <br/>
                    (B2C)</Card.Title>
                    <Card.Img variant="top" src={IconB2C} />
                    <Card.Text>
                      HBU Express melayani ribuan 
pelanggan korporat yang  mengantarkan barang 
ke kantor-kantor dan lokasi-lokasi bisnis.
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
              <Col sm={3} className=' p-3'>
              <Card className='layanan-card'>
                  
                  <Card.Body className='text-center'>
                    <Card.Title>Customer to Customer <br/>
                      (C2C)</Card.Title>
                      <Card.Img variant="top" src={IconC2C} />
                    <Card.Text>
                      HBU Express melayani ribuan 
pelanggan korporat yang  mengantarkan barang 
ke kantor-kantor dan lokasi-lokasi bisnis.
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
              <Col sm={3} className=' p-3'>
              <Card className='layanan-card'>
                 
                  <Card.Body className='text-center'>
                    <Card.Title>Cross Border Importation  <br/>
                      &
                      Value Added Services</Card.Title>
                      <Card.Img variant="top" src={CrosBorder} />
                    <Card.Text>
                      HBU Express melayani ribuan 
pelanggan korporat yang  mengantarkan barang 
ke kantor-kantor dan lokasi-lokasi bisnis.
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
        </Container>
    </div>
  )
}

export default index